import {
	getCommunitySearchHistoryList,
	getCommunitySearchHistoryStats,
} from '@/services/community/searchHistory.service'

export default {
	namespaced: true,
	state: {
		stats: null,
		statsStatus: 'init',
		list: {
			data: [],
			meta: {
				current_page: 1,
				last_page: 1,
				total: 0,
			},
		},
		listStatus: 'init',
	},
	getters: {
		getStats: state => state.stats,
		getStatsStatus: state => state.statsStatus,
		getList: state => state.list,
		getListStatus: state => state.listStatus,
	},
	mutations: {
		SET_STATS(state, value) {
			state.stats = value
		},
		SET_STATS_STATUS(state, value) {
			state.statsStatus = value
		},
		SET_LIST(state, value) {
			state.list = value
		},
		SET_LIST_STATUS(state, value) {
			state.listStatus = value
		},
	},
	actions: {
		async fetchStats({ commit }) {
			commit('SET_STATS_STATUS', 'loading')
			try {
				const res = await getCommunitySearchHistoryStats()
				commit('SET_STATS', res.data.data)
				commit('SET_STATS_STATUS', 'success')
				return res.data.data
			} catch (error) {
				commit('SET_STATS_STATUS', 'error')
				throw error
			}
		},
		async fetchList({ commit }, params = {}) {
			commit('SET_LIST_STATUS', 'loading')
			try {
				const res = await getCommunitySearchHistoryList(params)
				commit('SET_LIST', res.data)
				commit('SET_LIST_STATUS', 'success')
				return res.data
			} catch (error) {
				commit('SET_LIST_STATUS', 'error')
				throw error
			}
		},
	},
}
